export default __webpack_public_path__ + "static/media/koleos-colour-1.33bdc504.jpg";